import { Box, Button, Divider, Input, InputAdornment, MenuItem, Pagination, Stack, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { ROLE_MAPPING } from "../../../shared/constants/constants";
import UserBox from "./UserBox";
import PermissionsGate, { PartyRoleBasedPermissionsGate, RoleBasedPermissionsGate } from "../../privateRoute/permissionsGate";
import { PLATFORM_PERMISSIONS, PLATFORM_ROLES } from "../../../shared/models/abacConfig";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import CustomSpinner from "../../../shared/components/customSpinner/customSpinner";
import { Search } from "@mui/icons-material";

type Props = {
  handleUpdate: (user:any) => void;
  handleDelete: (arg0:any, arg1:any) => void;
  handleAdd: () => void;
  relations: any;
  users: any[];
  handlePageChange: any;
  pagination: any;
  setPagination: any;
  searchUser: string;
  setSearchUser: (value: string) => void;
  update: boolean;
  setUpdate: (value: boolean) => void;
};
export const UserList = ({
  handleAdd,
  handleDelete,
  handleUpdate,
  relations,
  users,
  handlePageChange,
  pagination,
  setPagination,
  searchUser,
  setSearchUser,
  update,
  setUpdate
}: Props) => {
  // console.log(users)
  const partyStoreState = useSelector((state: RootState) => state.party);
  return (
    <>
      {partyStoreState?.loading ? (
        <CustomSpinner size={"2rem"} />
      ) : (
        <>
          <Stack gap={1} mb={2}>
            <Typography fontWeight={600} fontSize={16} >Search User Name / Email Address</Typography>
              <Stack direction={"row"} gap={1}>
              <Input
                  placeholder="Search here"
                  sx={{
                    "backgroundColor": "#f6f6f6",
                    "height": "52px",
                    "paddingX": 2,
                    "width": "90%"
                  }}
                  value={searchUser}
                  onChange={(event) => setSearchUser(event?.target?.value)}
                  endAdornment={
                      <InputAdornment position="end">
                          <Search sx={{ marginRight: 1 }} />
                      </InputAdornment>
                  }
              />
            <Button
              onClick={() => setUpdate(!update)}
              variant="contained"
              sx={{
                backgroundColor: "#22438C",
                color: "#FFFFFF",
                borderRadius: 0,
                width: "10%"
              }}
          >
            Search
          </Button>
              </Stack>
          </Stack>
          <Box className="userBox" sx={{ boxShadow: users?.length > 0 ? "0px 10px 60px 0px #E2ECF980" : "", border: users?.length > 0 ? "1px solid #EEEEEE" : "" }}>
            {users?.length > 0 ? (
              users?.map((user, index) => {
                return (
                  <UserBox
                    handleDelete={handleDelete}
                    handleUpdate={handleUpdate}
                    user={user}
                    key={user?._id}
                    relations={relations}
                  />
                );
              })
            ) : (
              <Typography>No user found</Typography>
            )}
          </Box>
          <RoleBasedPermissionsGate roles={[PLATFORM_ROLES.SOCIETY]}>
            <PermissionsGate permissions={[PLATFORM_PERMISSIONS.PARTYMGR_CREATE]}>
            <Button
              variant="contained"
              className="addUserBtn"
              onClick={handleAdd}
            >
              Add users
            </Button>
            </PermissionsGate>
          </RoleBasedPermissionsGate>
          <Stack pt={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
          <Typography 
            >
              Showing data {pagination?.pageSize * (pagination?.page - 1) + 1} to {" "}
              {pagination?.pageSize * pagination?.page > pagination?.totalRecords
                ? pagination?.totalRecords
                : pagination?.pageSize * pagination?.page}{" "}
              from {pagination?.totalRecords}
          </Typography>
          <Pagination
              count={
                pagination?.totalRecords
                  ? pagination?.totalRecords % pagination?.pageSize == 0
                    ? pagination?.totalRecords / pagination?.pageSize
                    : Math.floor(pagination?.totalRecords / pagination?.pageSize) + 1
                  : 1
              }
              shape="rounded"
              page={pagination?.page}
              onChange={handlePageChange}
            />
          </Stack>
        </>
      )}
    </>
  );
};
